import { MODULE_NAME } from './const';
import { useEdges, useEdgesList } from './getters';
import { REMOVE_EDGE, SET_EDGE_DATA, SET_EDGES_DATA, CLEAR_EDGES_DATA } from './mutations';
import StoreModuleService from '../StoreModuleService';
import { arrayToObject } from '@/utils/helpers';
const buildEdgesActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const clearEdges = buildEdgesActionObject('clearEdges');
export const setEdgeData = buildEdgesActionObject('setEdgeData');
export const setEdgesData = buildEdgesActionObject('setEdgesData');
export const removeEdgeData = buildEdgesActionObject('removeEdgeData');
export const removeMultipleEdges = buildEdgesActionObject('removeMultipleEdges');
export const handleGraphEdgesAffectedChanges = buildEdgesActionObject('handleGraphEdgesAffectedChanges');
const actions = {
	...StoreModuleService.createDefaultActions(),
	[setEdgesData.action]({ commit, getters }, { data, clearPrevious = false }) {
		const allEdges = clearPrevious ? {} : getters[useEdges.getter];
		const newEdges = { ...allEdges, ...arrayToObject(data) };
		commit(SET_EDGES_DATA, { data: newEdges });
	},
	[setEdgeData.action]({ commit }, { id, data }) {
		commit(SET_EDGE_DATA, { id, data });
	},
	[removeEdgeData.action]({ commit }, { id }) {
		commit(REMOVE_EDGE, { id });
	},
	[clearEdges.action]({ commit }) {
		commit(CLEAR_EDGES_DATA);
	},
	async [removeMultipleEdges.action]({ dispatch, getters }, { ids }) {
		const allEdgesArr = getters[useEdgesList.getter];
		const newEdges = allEdgesArr.filter((edge) => !ids.includes(edge.id));
		await dispatch(setEdgesData.action, { data: newEdges, clearPrevious: true });
	},
	async [handleGraphEdgesAffectedChanges.action]({ dispatch }, { edges }) {
		const { created, updated, deleted } = edges;
		await dispatch(setEdgesData.action, { data: [...created, ...updated] });
		await dispatch(removeMultipleEdges.action, { ids: deleted });
	},
};

export default actions;
